var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDelete = function SvgDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "delete_svg__a",
    width: 25,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M.5 0h24v24H.5z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#delete_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.8 20.5c-.5 0-.925-.175-1.275-.525A1.736 1.736 0 0 1 6 18.7V6h-.25A.726.726 0 0 1 5 5.25a.726.726 0 0 1 .75-.75H9.5c0-.25.087-.458.262-.625a.892.892 0 0 1 .638-.25h4.2c.25 0 .463.083.638.25a.828.828 0 0 1 .262.625h3.75a.728.728 0 0 1 .75.75.728.728 0 0 1-.75.75H19v12.7c0 .5-.175.925-.525 1.275-.35.35-.775.525-1.275.525H7.8ZM7.5 6v12.7c0 .083.03.154.088.213A.289.289 0 0 0 7.8 19h9.4a.292.292 0 0 0 .213-.087.292.292 0 0 0 .087-.213V6h-10Zm2.4 10.25a.728.728 0 0 0 .75.75c.217 0 .396-.07.538-.212a.731.731 0 0 0 .212-.538v-7.5a.731.731 0 0 0-.212-.538A.731.731 0 0 0 10.65 8a.728.728 0 0 0-.75.75v7.5Zm3.7 0c0 .217.07.396.212.538a.731.731 0 0 0 .538.212c.217 0 .396-.07.538-.212a.731.731 0 0 0 .212-.538v-7.5a.731.731 0 0 0-.212-.538A.731.731 0 0 0 14.35 8a.731.731 0 0 0-.538.212.731.731 0 0 0-.212.538v7.5ZM7.5 6v12.7c0 .083.03.154.088.213A.289.289 0 0 0 7.8 19h-.3V6Z"
  }))));
};
export default SvgDelete;